import prefix from "vendor-prefix";
import $ from "jquery";

let scrollableText;

var move = () => {
  $(scrollableText).each((i, title) => {
    let heading = title.querySelector("h2");

    let objHeight = title.offsetHeight;

    let perc =
      (title.offsetTop + objHeight - (window.scrollY || window.pageYOffset)) /
      (vh + objHeight);
    perc = perc * 100;
    perc = Math.round(perc) / 100;
    perc = 1 - perc;

    distance = heading.offsetWidth * 2;
    offset = heading.offsetWidth - distance * perc;
    heading.style[prefix("transform")] = `translateX(${offset}px)`;
  });

  requestAnimationFrame(move);
};

var init = (selector) => {
  scrollableText = document.querySelectorAll(selector);

  $(scrollableText).each((i, title) => {
    let heading = title.querySelector("h2");
    let objWidth = title.offsetWidth;
    heading.style[prefix("transform")] = `translateX(${objWidth}px)`;
    title.setAttribute("data-width", objWidth);
  });
};

class TextScroller {
  constructor(selector) {
    init(selector);
  }
  init() {
    requestAnimationFrame(move);
  }
}

export default TextScroller;
